module.exports = fox._r("images/press/icon-email.png", __webpack_public_path__ + "_/common/images/press/icon-email.png");


//////////////////
// WEBPACK FOOTER
// ../common/images/press/icon-email.png
// module id = 377
// module chunks = 2